(() => {
  const landing = document.querySelector('.fs-javvy[data-landing-variant="FS-LP4-JAVVY-OWN-ART-11"]')
  const funnel = document.querySelector('[data-dtfs-free-sample]')
  const question = document.querySelector('#dtfs-fs-question')
  if (!landing || !funnel || !question) return
  const preserveOpenScreen = () => {
    if (funnel.classList.contains('is-credit-handoff') || (funnel.dataset.currentScreen && funnel.dataset.currentScreen !== 'experience')) document.body.classList.add('fs-javvy-funnel-open')
  }
  preserveOpenScreen()
  document.body.classList.add('fs-javvy-funnel-ready')
  new MutationObserver(preserveOpenScreen).observe(funnel, { attributes: true, attributeFilter: ['data-current-screen', 'class'] })
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return
    const cta = event.target.closest('.fs-javvy [data-fs-funnel-cta]')
    if (cta) document.body.classList.add('fs-javvy-funnel-open')
  }, true)
})()
